import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rds-loading-calendar',
  templateUrl: './loading-calendar.component.html',
  styleUrls: ['./loading-calendar.component.scss']
})
export class LoadingCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
